import * as React from 'react'
import { tableStyles } from './useTableStyles'
import { ServiceIcon } from '@sales-center/components'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import TableFooter from '@mui/material/TableFooter'

interface Props {
  externalLinkId: string
}

export const SoldServicesTable: React.FC<Props> = () => {
  const { header } = tableStyles

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={header}>
            <ServiceIcon width={42} height={42} />
          </TableCell>
          <TableCell sx={header}>Date Sold</TableCell>
          <TableCell sx={header}>Service</TableCell>
          <TableCell sx={header}>Opportunity</TableCell>
          <TableCell sx={header}>Value</TableCell>
        </TableRow>
      </TableHead>
      <TableBody></TableBody>
      <TableFooter></TableFooter>
    </Table>
  )
}
SoldServicesTable.displayName = 'SoldServicesTable'
